(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name payments.factory:CreditAccountRegisterService
     *
     * @description
     *
     */
    angular
        .module('payments')
        .factory('CreditAccountRegisterService', CreditAccountRegisterService);

    function CreditAccountRegisterService(EndpointsService, $q, $http, $log) {
        var CreditAccountRegisterServiceBase = {};
        CreditAccountRegisterServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                //$log.debug("Params:", params);
                $http.get(response.links.creditAccountRegister, {
                        params: params
                    })
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };

        CreditAccountRegisterServiceBase.getByIban = function (iban) {
            var predefinedParams = {
                iban: iban
            };
            return CreditAccountRegisterServiceBase.getPage(predefinedParams);
        };

        CreditAccountRegisterServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.creditAccountRegister_id.replace('{id}', id))
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };
        return CreditAccountRegisterServiceBase;
    }
}());
